import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import useMeterInput from '@/containers/SubscriptionFormPageNew/Components/GasMeter/Fields/MeterInput/useMeterInput'
import PceSearchButton from '@/containers/SubscriptionFormPageNew/Components/GasMeter/PceSearch/PceSearchButton'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import CopyEndEnhancer from '@/shared/components/SDComponentsNewDesign/CopyEndEnhancer/CopyEndEnhancer'

const MeterInput = () => {
  const {
    meterIdOnBlurHandler,
    meterSerialOnBlurHandler,
    gridOperatorOnBlurHandler,
    pceNo,
    meterSerialNumber,
    showMeterSerialNumber,
    gridOperator,
    showGridOperator,
    meterIdLabel,
    isEditable,
    lastSentDate,
    meterStatus,
    showPceSearchButton,
    meterIdMaxLength,
    errors,
    t,
    isPulse,
  } = useMeterInput()

  return (
    <>
      <SDFormControl plainLabel error={getError('meter_id_gas', errors)}>
        <>
          <SDInput
            disabled={isEditable === false || lastSentDate}
            onBlur={value => meterIdOnBlurHandler(value)}
            currentValue={pceNo}
            label={meterIdLabel}
            placeholder={t('subscriptionForm:pce_module.meter_id.placeholder')}
            maxLength={meterIdMaxLength}
            status={meterStatus}
            endEnhancer={<CopyEndEnhancer value={pceNo} />}
            button={<PceSearchButton hidden={!showPceSearchButton} />}
          />
        </>
      </SDFormControl>
      <SDFormControl
        hidden={!showMeterSerialNumber}
        caption={t('subscriptionForm:pce_module.meter_serial_number.caption')}
      >
        <SDInput
          disabled={isEditable === false || lastSentDate}
          onBlur={value => meterSerialOnBlurHandler(value)}
          currentValue={meterSerialNumber}
          label={meterSerialNumber || isPulse ? t('subscriptionForm:pce_module.meter_serial_number.label') : ''}
          placeholder={t('subscriptionForm:pce_module.meter_serial_number.placeholder')}
          endEnhancer={<CopyEndEnhancer value={meterSerialNumber} />}
        />
      </SDFormControl>
      <SDFormControl hidden={!showGridOperator}>
        <SDInput
          disabled={isEditable === false || lastSentDate}
          onBlur={value => gridOperatorOnBlurHandler(value)}
          currentValue={gridOperator}
          label={gridOperator || isPulse ? t('subscriptionForm:pce_module.grid_operator.label') : ''}
          placeholder={t('subscriptionForm:pce_module.grid_operator.placeholder')}
          endEnhancer={<CopyEndEnhancer value={gridOperator} />}
        />
      </SDFormControl>
    </>
  )
}

export default MeterInput
